import React, { useState, useEffect, useRef } from 'react';
import './Scrollytelling.css';
import { db } from '../firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import ReactMarkdown from 'react-markdown';
import ExperienceModal from './ExperienceModal';

const ScrollytellingItem = ({ experience, isFirst, onOpenModal }) => {
  const [isVisible, setIsVisible] = useState(false);
  const itemRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.4,
      }
    );

    const currentRef = itemRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div className={`scrolly-item ${isVisible ? 'is-visible' : ''} ${isFirst ? 'is-first' : ''}`} ref={itemRef}>
      <div className="scrolly-video-background">
        {(experience.mediaType === 'video' || (!experience.mediaType && experience.videoUrl)) && experience.videoUrl ? (
          <video autoPlay loop muted playsInline key={experience.id}>
            <source src={experience.videoUrl} type="video/mp4" />
          </video>
        ) : experience.mediaType === 'image' && experience.imageUrl ? (
          <img src={experience.imageUrl} alt={experience.title} className="scrolly-video" />
        ) : null}
      </div>
      <div className="scrolly-content" onClick={() => onOpenModal(experience)}>
        <h2>{experience.title}</h2>
        <p>{experience.description}</p>
      </div>
    </div>
  );
};

function Scrollytelling() {
  const [experiences, setExperiences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalExperience, setModalExperience] = useState(null);

  useEffect(() => {
    const fetchExperiences = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'experiences'));
        const experiencesList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setExperiences(experiencesList);
      } catch (error) {
        console.error('Error fetching experiences for Scrollytelling:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchExperiences();
  }, []);

  const handleOpenModal = (experience) => {
    setModalExperience(experience);
  };

  const handleCloseModal = () => {
    setModalExperience(null);
  };

  if (loading) {
    return <div className="scrolly-container">Cargando experiencias para Scrollytelling...</div>;
  }

  if (experiences.length === 0) {
    return <div className="scrolly-container">No hay experiencias disponibles para Scrollytelling.</div>;
  }

  return (
    <div className="scrolly-container">
      {experiences.map((exp, index) => (
        <ScrollytellingItem 
          key={exp.id} 
          experience={exp} 
          isFirst={index === 0}
          onOpenModal={handleOpenModal}
        />
      ))}
      {modalExperience && (
        <ExperienceModal 
          experience={modalExperience} 
          onClose={handleCloseModal} 
        />
      )}
    </div>
  );
}

export default Scrollytelling;
